import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserModel } from '../../_models/user.model';
import { environment } from '../../../../../environments/environment';
import { AuthModel } from '../../_models/auth.model';
import { AppHttpClient } from 'src/app/core/services/http-call/http-call.service';
import { DeviceType } from 'src/app/core/app.constants';

const API_USERS_URL = `${environment.apiUrl}v1/auth`;

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(private http: AppHttpClient) { }

  // public methods
  login(email: string, password: string): Observable<any> {
    return this.http.post<AuthModel>(`${API_USERS_URL}/login`, { email, password });
  }

  // CREATE =>  POST: add a new user to the server
  createUser(user: UserModel): Observable<UserModel> {
    return this.http.post<UserModel>(API_USERS_URL, user);
  }

  // Your server should check email => If email exists send link to the user and return true | If email doesn't exist return false
  forgotPassword(email: string): Observable<boolean> {
    return this.http.post<boolean>(`${API_USERS_URL}/forgotPassword`, {
      email,
    });
  }

  updateProfile(profileDetails: UserModel) {
    return this.http.put<boolean>(`${API_USERS_URL}/profile`, profileDetails);
  }

  changePassword(oldPassword: string, newPassword: string) {
    return this.http.post<boolean>(`${API_USERS_URL}/changePassword`, {
      oldPassword,
      newPassword
    });

  }


  resetPassword(token: string, password: string) {
    return this.http.post<boolean>(`${API_USERS_URL}/resetPassword`, {
      token,
      password
    });
  }

  resetPasswordForUser(token: string, password: string) {
    let url = API_USERS_URL.replace('/api/', '/app/');
    return this.http.post<boolean>(`${url}/resetPassword`, {
      token,
      password
    });
  }


  getUserByToken(token): Observable<UserModel> {

    return this.http.get<UserModel>(`${API_USERS_URL}/profile`);
  }


  addDeviceToken(token: string, deviceType: DeviceType = DeviceType.WEB): Observable<void> {
    return this.http.post<void>(`${API_USERS_URL}/deviceToken`, {
      token,
      deviceType
    });
  }

  logout(fcmToken: string | null): Observable<any> {
    return this.http.post<any>(`${API_USERS_URL}/logout`, { fcmToken });
  }
}
